"use client";
import React from 'react';
import { motion } from 'framer-motion';

export default function GoogleAdsBeyondClicks() {
    return (
        <section className="relative overflow-hidden py-20 md:py-28 px-6 md:px-16 lg:px-24" style={{ background: '#080400' }}>
            <div className="max-w-[900px] mx-auto relative z-10 flex flex-col gap-6">
                <motion.span
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="text-xs font-bold tracking-[0.2em] uppercase"
                    style={{ color: '#ceff1a', fontFamily: 'var(--font-clash), "Clash Display", sans-serif' }}
                >
                    Beyond Vanity Metrics
                </motion.span>

                <motion.h2
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.1 }}
                    className="text-3xl md:text-5xl font-bold tracking-tight leading-tight"
                    style={{ fontFamily: 'var(--font-clash), "Clash Display", sans-serif', color: '#fbfdfd' }}
                >
                    We Optimise for More Than Clicks
                </motion.h2>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="flex flex-col gap-5"
                >
                    <p
                        className="text-base md:text-lg leading-relaxed"
                        style={{ fontFamily: 'var(--font-manrope), Manrope, sans-serif', color: 'rgba(255,255,255,0.6)', letterSpacing: '0.02em' }}
                    >
                        A campaign can generate thousands of clicks and still fail to generate meaningful business results.
                    </p>
                    <p
                        className="text-base md:text-lg leading-relaxed"
                        style={{ fontFamily: 'var(--font-manrope), Manrope, sans-serif', color: 'rgba(255,255,255,0.6)', letterSpacing: '0.02em' }}
                    >
                        That&apos;s why we look beyond impressions and CTR to understand conversion rate, lead quality, customer acquisition cost, revenue and return on ad spend.
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
